
const serviceOptionsMap = [
  { message: 'aktiv', key: 'active' },
  { message: 'inaktiv', key: 'inactive' }
]
export { serviceOptionsMap }
